module.exports = __webpack_public_path__ + "static/media/night_flight_sample_7.c9136448.jpg";